import { gql } from '@apollo/client';

import { interactiveAssessmentFragment } from '../assessment/assessment-builder.graphql';

export const GET_PUBLISHED_ASSESSMENT_ACTIVITIES_BY_VERSION = gql`
  query GetPublishedAssessmentActivitiesByVersion(
    $input: GetPublishedAssessmentActivitiesByVersionInput!
  ) {
    getPublishedAssessmentActivitiesByVersion(input: $input) {
      ...AssessmentActivities
    }
  }
  ${interactiveAssessmentFragment}
`;
